import React from "react";

import { IClass, ITeacher } from "../../../state";

import style from "./ClassList.module.scss";

export interface IClassListDispatchProps {
  title: string;
  isNextYear: boolean;
  toBuildClass: (id: number) => void;
  toBuildNewClass: () => void;
  toBulkEditClasses: () => void;
  changeYear?: (year: number) => void;
}

export interface IClassListStateProps {
  classes: IClass[];
  teachers: ITeacher[];
  year: number;
}

export interface IClassListProps
  extends IClassListDispatchProps,
    IClassListStateProps {}

export const ClassList = (props: IClassListProps) => {
  return (
    <div className={style.list}>
      <div className="d-flex align-items-center mb-5">
        <h3 className="me-4 mb-0">{props.title}</h3>
        <span>
          {props.year}
          年度にENAGEED教材を使うクラスのご登録、編集が可能です。
        </span>
      </div>
      <div className={style.selectArea}>
        <div>
          <button
            className={"btn btn-outline-primary " + style.registerBtn}
            onClick={e => {
              e.preventDefault();
              props.toBuildNewClass();
            }}
          >
            新規クラス登録
          </button>
          <button
            className="btn btn-outline-primary"
            onClick={e => {
              e.preventDefault();
              props.toBulkEditClasses();
            }}
          >
            クラス一括編集
          </button>
        </div>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th className="px-3">学年</th>
            <th>クラス名</th>
            <th>担当</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {props.classes.map(c => {
            return (
              <tr key={c.id}>
                <td className="ps-4">
                  <span className={style.roomLink}>{c.grade}</span>
                </td>
                <td className="font-weight-bold">{c.full_name}</td>
                <td>
                  {props.teachers
                    .filter(t => t.class_ids.indexOf(c.id) !== -1)
                    .map((t, idx) => (
                      <div key={idx}>{t.last_name + " " + t.first_name}</div>
                    ))}
                </td>
                <td>
                  <div className={style.utilBtnArea}>
                    <button
                      className="btn btn-outline"
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.toBuildClass(c.id);
                      }}
                    >
                      編集
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default ClassList;
